import PropertyDetailsCard from './PropertyDetailsCard';

export default PropertyDetailsCard;
export * from './property-detail-rows';
